import { createSlice } from '@reduxjs/toolkit';
import { calcPrice } from 'utils/calc-gear-price';
import { gearGrade } from 'config/config';
const name = 'purchase';

const initialState = {
  round: 1,
  price: 0,
  grade: gearGrade.rare,
  amount: 1,
  discount: 0,
  cost: 0,
  total: 0,
  rest: 0,
};

export const purchaseSlice = createSlice({
  name: name,
  initialState,
  reducers: {
    setInfo: (state, action) => {
      state.round = action.payload?.roundId ?? 0;
      state.price = action.payload?.price ?? 0;
      state.grade = gearGrade.rare;
      state.amount = 1;
      state.cost = calcPrice(gearGrade.rare, action.payload?.price ?? 0) * 1;
      state.discount = action.payload?.discount ?? 0;
      state.total = action.payload?.amount ?? 0;
    },
    setGrade: (state, action) => {
      const grade = action.payload ?? gearGrade.normal;
      state.grade = grade;
      state.amount = 1;
      state.cost = calcPrice(grade, state.price) * 1;
    },
    setAmount: (state, action) => {
      const amount = action.payload ?? 0;
      state.amount = amount;
      state.cost = calcPrice(state.grade, state.price) * amount;
    },
    setRest: (state, action) => {
      state.rest = action.payload ?? 0;
    },
  },
});

export const { setInfo, setGrade, setAmount, setRest } = purchaseSlice.actions;

export default purchaseSlice.reducer;
